// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"8d70978c","452":"12972a63","548":"96c72a21","750":"b7a426fe","822":"51b31d52","826":"587857e1"}[chunkId] + ".1792712899448.chunk.js";
};